'use client';

import { createBrowserClient } from '@supabase/ssr';

export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookies: {
        getAll() {
          if (typeof document === 'undefined') return [];
          return document.cookie
            .split(';')
            .filter(Boolean)
            .map((c) => {
              const idx = c.trim().indexOf('=');
              const name = idx !== -1 ? c.trim().slice(0, idx) : c.trim();
              const value = idx !== -1 ? decodeURIComponent(c.trim().slice(idx + 1)) : '';
              return { name: name.trim(), value };
            })
            .filter((c) => c.name);
        },
        setAll(cookiesToSet) {
          if (typeof document === 'undefined') return;
          cookiesToSet.forEach(({ name, value, options }) => {
            if (!value) {
              // Delete cookie
              document.cookie = `${name}=; Path=${options?.path || '/'}; Max-Age=0; SameSite=Lax`;
            } else {
              let cookieStr = `${name}=${encodeURIComponent(value)}; Path=${options?.path || '/'}; SameSite=Lax`;
              if (options?.maxAge) cookieStr += `; Max-Age=${options.maxAge}`;
              if (options?.expires) cookieStr += `; Expires=${new Date(options.expires).toUTCString()}`;
              document.cookie = cookieStr;
            }
          });
        },
      },
    }
  );
}
